import {useState, useEffect  } from "react";

// Chakra imports
import { Flex, FormControl, FormLabel, Spinner, SimpleGrid, Button, LightMode, useColorModeValue , Icon, useToast, Image } from '@chakra-ui/react';

import { RiFileExcel2Line, RiSearch2Line } from 'react-icons/ri';


import InputField from "components/fields/InputField";


import tracking from 'assets/img/tracking.png';

export default function Actions(props: {
	[x: string]: any;
	onChange: any;
	disabledActions: boolean;
	showProgressSearch: boolean;
}) {
	
	
	const toast = useToast()
	const [filtroBl, setSetFiltroBl] = useState('');
	const [filtroContenedor, setSetFiltroContenedor] = useState('');

	const handlerSearchClick = () => {
		if (filtroBl === '' && filtroContenedor === '') {

			toast({
				title: 'Filtros vacios',
				description: 'Debe introducir el B/L o el Contenedor para realizar la busqueda',
				status: 'info',
				duration: 9000,
				isClosable: true,
			  });

			return;
		}

		props.onChange({
			filtroBl,
			filtroContenedor
		});
	};
	const handlerChangeBl = (e:any) => {
		setSetFiltroBl(e.target.value)
	};
	const handlerChangeContenedor = (e:any) => {
		setSetFiltroContenedor(e.target.value)
	};

	return (
		<FormControl>
		<Image src={tracking}  mb='10px'/>
				<SimpleGrid columns={{ sm: 1, md: 2 , xl: 3}} spacing={{ base: '15px', xl: '15px' }}>

				<InputField mb='0px' me='30px' id='inputFilterBL' label='B/L' value={filtroBl} onChange={handlerChangeBl} />

				<InputField mb='0px' me='30px' id='inputFilterConteiner' label='Contenedor' value={filtroContenedor} onChange={handlerChangeContenedor} />
				</SimpleGrid>
                        <Flex flexDirection={{ base: 'column', md: 'row' }} mt='15px'>
                            <Button ml='auto' variant='brand' fontSize='sm' fontWeight='500' onClick={handlerSearchClick} isDisabled={props.disabledActions}>
							<Icon as={RiSearch2Line} width='20px' height='20px' color='inherit' mr='10px' /> Buscar
          <Spinner
              size='sm'
			  ml='5px'
			  hidden={!props.showProgressSearch}
            />
                            </Button>
                        </Flex>	
		</FormControl>
	);
}
